<section>
  @if (label && label !='') {
    <div id="termlength" class="active">
      <mat-label aria-label="{{ displayLabel | translate }}">{{ displayLabel | translate }}**</mat-label>
    </div>
  }
  <mat-form-field appearance="fill">
    <select id="selectDropdown" matNativeControl [(ngModel)]="selected" name="selectField" required #selectControl="ngModel">
      @for (option of options; track option) {
        <option [value]="option.value" [disabled]="option.disabled" [selected]="option.value === selected">
          {{ option.display }}
        </option>
      }
    </select>
    @if (errorFlag && selectControl.invalid) {
      <mat-error>
        {{errorMessage}}
      </mat-error>
    }
  </mat-form-field>
</section>
